module.exports = __webpack_public_path__ + "static/media/Buy_Now_Button@3x.67ea8f0c.png";